import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

var _Getters;

import * as types from "@/store/constants/types";
var Getters = (_Getters = {}, _defineProperty(_Getters, types.GETTER_VIP_RELATE_DATA, function (state) {
  return function (payload) {
    var func = payload.func,
        name = payload.name;
    return state[func][name];
  };
}), _defineProperty(_Getters, types.GETTER_VIP_ROUTER_DATA, function (state) {
  return state.vipRouterData;
}), _defineProperty(_Getters, types.GETTER_CARD_CLICK_TIMES, function (state) {
  return state.cardClickTimes;
}), _Getters);
export default Getters;